<template>
  <div>
    <div class="row">
      <div class="flex md2 sm12 lg9">
        <h1>{{ $t('administrarivo.Avaliacao') }}</h1>
      </div>
      <div v-if="novo" class="flex xs12 sm12 lg3">
        <va-button
          class="text-right"
          :color="BuNovo.color"
          :style="BuNovo"
        >{{ $t('Geral.Adicionar') }}</va-button>
      </div>
    </div>
    <div v-if="!novo">
      <form @submit.prevent="addNovo()">
        <div class="row">
          <div class="flex md2 sm12 lg3">
            <va-input
              :label="$t('forms.selects.simple')"
              v-model="AddAvac.nome"
              placeholder="Nome"
            />
          </div>

          <div class="flex md2 sm12 lg3">
            <va-input
              :label="$t('forms.selects.simple')"
              v-model="AddAvac.data_abertura"
              type="date"
              placeholder="Fecha Inicio"
            />
          </div>

          <div class="flex md3 sm12 xs12">
            <va-input
              :label="$t('forms.selects.simple')"
              v-model="AddAvac.data_encerramento"
              type="date"
              placeholder="Fecha Encerramento"
            />
          </div>
          <!-- <div class="flex md3 sm12 xs12">
            <va-select
              :label="$t('forms.selects.simple')"
              v-model="tipo_avaliacao"
              textBy="nome_disciplina"
              :options="getAllMateriasCurso"
              placeholder="Tipo de Avaliacao"
            />
          </div> -->
          <div class="flex md12 sm12 xs12 text--right">
            <va-button type="submit" class="text-right" color="dark">{{ $t('arealuno.Inserir') }}</va-button>
          </div>
        </div>
      </form>
    </div>

    <va-data-table :fields="fields" :data="getAvac" hoverable no-pagination>
      <template slot="marker" slot-scope="props">
        <va-icon name="fa fa-circle" :color="props.rowData.color" size="8px" />
      </template>

      <template slot="actions" slot-scope="props">
        <va-button
          flat
          small
          color="success"
          @click="abrir_conteudos(props.rowData)"
          class="ma-0"
        >Perguntas</va-button>

        <va-button
          flat
          small
          color="info"
          @click="edit(props.rowData)"
          class="ma-0"
        >{{ $t('tables.edit') }}</va-button>
      </template>
    </va-data-table>
  </div>
</template>

<script>
export default {
  name: "addprofessor",

  data() {
    return {
      BuNovo: {
        color: "info",
        width: "100%"
      },
      AddAvac: {
        // grade_curricular: "",
        nome: "",
        data_abertura: "",
        data_encerramento: "",
        tipo_avaliacao_id: ""
      },
      tipo_avaliacao: "",
      novo: false

 
    };
  },
  created() {
    this.all();
    this.materiaCurso();
  },
  computed: {
    getAvac(){
      return this.$store.state.avaliacao.allAvaliacoes;
    },
    getdados() {
      return this.$store.state.datamateria.datamateria;
    },
    getAllMateriasCurso() {
      return this.$store.state.datamateria.allmateriacurso;
    },

    fields() {
      return [
        {
          name: "__slot:marker",
          width: "30px",
          dataClass: "text-center"
        },
        {
          name: "id",
          title: this.$t("tables.headings.name")
        },
        {
          name: "nome",
          title: this.$t("tables.headings.name")
        },
        {
          name: "data_abertura",
          title: this.$t("tables.headings.name")
        },
        {
          name: "data_encerramento",
          title: this.$t("tables.headings.name")
        },
        {
          name: "__slot:actions",
          dataClass: "text-right"
        }
      ];
    }
  },

  methods: {
    abrir_conteudos(value) {
      this.$store.dispatch("setAvaliacao", value);
       this.$emit('trocar_component', 'addofertaPergunta');
    },

    all() {
    
      this.$store.dispatch("allAvaliacoes", this.$store.state.datamateria.setmateria.id)
    
    },
    
    materiaCurso() {
      this.$store.dispatch(
        "allMateriaCurso",
        this.$store.state.gradecurricular.dados_gradecurricular
          .grade_curricular_id
      );
    },
 async   addNovo() {
console.log(this.$store.state.datamateria.setmateria)
      let insert = {
        nome: this.AddAvac.nome,
        data_abertura: this.AddAvac.data_abertura,
        data_encerramento: this.AddAvac.data_encerramento,
        tipo_avaliacao_id: 1,
        oferta_data_disciplina_id: this.$store.state.datamateria.setmateria.id ,

      }

  await  this.$store.dispatch('addAvaliacao',insert)

      this.AddAvac = {
    
        nome: "",
        data_abertura: "",
        data_encerramento: "",
         tipo_avaliacao_id: ""
      }
         this.all();
    }
  }
};
</script>

<style lang="scss">
</style>
